import "./index.scss";
export const HeaderButtons = ({children}) => {
    return (
        <div className="page-header-buttons">
            {children}
        </div>
    )
}